import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import InvoiceForm from '../components/InvoiceForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import { Print } from '@mui/icons-material';
import invoiceServices from '../invoiceServices';
import { Link } from 'react-router-dom';
import GenerateInvoice from '../components/GenerateInvoice';



const CellActions = (props) =>{
    return(
        <>
            <Link to={`/invoice/details/${props.data.id}`}>{props.data.invoiceNumber}</Link>
        </>
    )
  }


function InvoiceDashboardPage() {

  const {getMasterLabel, companyDD, customerDD,getDDDataById} = useAppData()
  const [invoiceList,setInvoiceList] = useState(null);
  const gridRef = useRef();
  
  const getInvoiceList =() =>{
    invoiceServices.getList().then(res=>{
      setInvoiceList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "Invoice #",width:50},
        {headerName:"Invoice #", width:150, field:"invoiceNumber", 
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getInvoiceList,
                remove:remove
            },
        },

        {headerName: "Company / Firm", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(companyDD,params.data.companyId);
            return _data.label;
          }
        },
        {headerName: "Customer", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(customerDD,params.data.customerId);
            return _data.label;
          }
        },
        {field:"invoiceDate",headerName: "Invoice Date",width:150},
        {field:"paymentDueDate",headerName: "Payment Due Date",width:150},
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Invoice Dashboard</h4></div>
        <div className='col-md-6'> 
          
          <span className='float-end mx-2'><GenerateInvoice callBack={getInvoiceList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={invoiceList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getInvoiceList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default InvoiceDashboardPage